import {library} from '@fortawesome/fontawesome-svg-core'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {faCheckSquare, faCoffee} from '@fortawesome/free-solid-svg-icons'
import {faAddressCard} from '@fortawesome/pro-solid-svg-icons'


library.add(fab, faCoffee, faCheckSquare, faAddressCard)
